import { useParams } from "react-router-dom";
import FolderDetailsContent from "containers/admin/clients/campaign/campaign-creative-page/folder-details/components/folder-details-content/folder-details-content";

const FolderDetails = () => {
  const { folderId } = useParams();

  if (!folderId) {
    return null;
  }

  return <FolderDetailsContent />;
};

export default FolderDetails;
